import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import './css/bootstrap.min.css';
import './font-awesome/css/font-awesome.min.css';
import { Provider } from 'react-redux';
import store from './store';
import intl from 'react-intl-universal';
import './css/bootstrap.min.css';
import './css/style.css';
import 'antd'; // 添加一个空白的导入语句
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import zhCNAntd from 'antd/lib/locale/zh_CN';

import enUS from './components/intl/en-US.json';
import zhCNIntl from './components/intl/zh-CN.json';
import deDE from './components/intl/de-DE.json';

const locales = {
	"en": enUS,
	"zh-cn": zhCNIntl,
	"de": deDE,
};

if (localStorage.getItem('locale')) {
	intl.init({
		currentLocale: localStorage.getItem('locale'),
		locales: locales
	});
} else {
	intl.init({
		currentLocale: 'zh-cn',
		locales: locales
	});
	localStorage.setItem('locale', 'zh-cn');
}

React.Component.prototype.$intl = intl;

const container = document.getElementById('root');
ReactDOM.render(
	<Suspense fallback={<span> </span>}>
		<Provider store={store}>
			<ConfigProvider locale={zhCNAntd}
				theme={{
					token: {
						borderRadius: 0,
					},
				}}
			>
				{/* <StyleProvider hashPriority="high"> */}
					<App />
				{/* </StyleProvider> */}
			</ConfigProvider>
		</Provider>
	</Suspense>,
	container
);
